import { render } from "./ProductCard.vue?vue&type=template&id=4808d221&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=4808d221&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4808d221"]])

export default __exports__